import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import LinkTransType from 'components/UI/LinkTransType'
import { transType } from 'utils/static'
import useMemoizeCheckPermission from 'utils/hooks/useMemoizeCheckPermission'

const RefNumberTitle = () => {
  const { formatMessage } = useIntl()
  const isHasAccessAutomaticSequencing = useMemoizeCheckPermission({
    permission: 'automatic_sequencing',
  })

  return (
    <>
      <FormattedMessage id="financeInvoices.the_number_will_be_automatically_generated_by_the_system" />
      {isHasAccessAutomaticSequencing && (
        <>
          {' '}
          <FormattedMessage
            id="financeInvoices.you_can_set_the_format_of_this_number"
            values={{
              link: (
                <LinkTransType
                  title={formatMessage({ id: 'financeInvoices.here' })}
                  transTypeId={transType.NUMBER}
                  data={{}}
                />
              ),
            }}
          />
        </>
      )}
    </>
  )
}

export default React.memo(RefNumberTitle)
